export const translationIS = {
  translation: {
    navBar: {
      title: {
        calendar: "Veldu dagsetningar",
        accommodation: "Gisting",
        extras: "Aukahlutir",
        summary: "Yfirlit",
        details: "Upplýsingar",
        payment: "Greiðsla",
        success: "Staðfesting",
      },
    },
    cart: {
      title: {
        calendar: "Skoða gistingu",
        accommodation: "Áfram í aukahluti",
        extras: "Yfirlit yfir bókun",
        summary: "Sláðu inn upplýsingar þínar",
        details: "Áfram í greiðslu",
        payment: "Ljúka bókun",
      },
      selectArrivalDate: "Vinsamlegast veldu komudag",
      selectDepartureDate: "Vinsamlegast veldu brottfarardag",
      priceFrom: "Frá",
    },
    weekDays: ["Su", "Má", "Þr", "Mi", "Fi", "Fö", "La"],
    months: [
      "Janúar",
      "Febrúar",
      "Mars",
      "Apríl",
      "Maí",
      "Júní",
      "Júlí",
      "Ágúst",
      "September",
      "Október",
      "Nóvember",
      "Desember",
    ],
    shortMonths: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "Maí",
      "Jún",
      "Júl",
      "Ágú",
      "Sep",
      "Okt",
      "Nóv",
      "Des",
    ],
    accommodation: {
      AMS: {
        tags: [],
        hub: {
          title: "Hub",
          excerpt:
            "Þinn eigin einka Hub fyrir allt að 2 ferðalanga með king-size rúmi. Fullkomið fyrir ferðalanga á eigin vegum, vini eða pör sem elska þægindi.",
          description:
            "Þinn eigin einka Hub fyrir allt að 2 ferðalanga með king-size rúmi. Fullkomið fyrir ferðalanga á eigin vegum, vini eða pör sem elska þægindi.",
          imagePath: "/assets/images/accomodation/hub_AMS/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Hub-inn er lagaður eins og L",
            },
            { src: "see_the_top_hub.jpg", alt: "Sjá efri Hub" },
            { src: "inside_the_top_hub.jpg", alt: "Inni í efri Hub" },
            { src: "see_the_bottom_hub.jpg", alt: "Sjá neðri Hub" },
            { src: "inside_the_bottom_hub.jpg", alt: "Inni í neðri Hub" },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Slakaðu á í hjónarúmi",
            },
            {
              src: "yes_you_can_sit_up_in_bed.jpg",
              alt: "Já, þú getur setið uppréttur í rúminu",
            },
            {
              src: "play_your_music_with_bluetooth.jpg",
              alt: "Spilaðu tónlist með Bluetooth",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Farðu í sturtu í kímónóunum okkar",
            },
            { src: "men_s_bathroom.jpg", alt: "Snyrting karla" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Hressaðu þig við undir regnsturtunni",
            },
            { src: "women_s_bathroom.jpg", alt: "Snyrting kvenna" },
            { src: "hair_&_makeup_area.jpg", alt: "Hár- og förðunaraðstaða" },
          ],
        },
        howManyTravellers: {
          title: "Hversu margir ferðalangar?",
          content:
            "Öll rýmin okkar eru með notaleg rúm, stemningslýsingu og nýjustu tækni. Eina spurningin er: hvernig vilt þú dvelja? <br /><br />Hub-arnir okkar eru fullkomnir fyrir einfara og pör eða vini sem njóta þess að hafa næði og notalega stemningu.<br /><br />Veldu 1 til 4 ferðamenn til að sjá verðbreytinguna.",
        },
        addAnotherAccomodation: {
          title: "Bæta við Hub",
          hub: {
            title: "Hub",
            description:
              "Einka Hub með hjónarúmi – fullkomið fyrir einn eða tvo ferðalanga.",
          },
        },
      },
      CPH: {
        tags: ["Sauna á staðnum"],
        hub: {
          title: "Hub",
          excerpt:
            "Þinn eigin einka Hub fyrir allt að 2 ferðalanga með king-size rúmi. Fullkomið fyrir ferðalanga á eigin vegum, vini eða pör sem elska þægindi.",
          description:
            "Þinn eigin einka Hub fyrir allt að 2 ferðalanga með king-size rúmi. Fullkomið fyrir ferðalanga á eigin vegum, vini eða pör sem elska þægindi.",
          imagePath: "/assets/images/accomodation/hub_CPH/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Hub-inn er lagaður eins og L",
            },
            { src: "see_the_top_hub.jpg", alt: "Sjá efri Hub" },
            { src: "inside_the_top_hub.jpg", alt: "Inni í efri Hub" },
            { src: "see_the_bottom_hub.jpg", alt: "Sjá neðri Hub" },
            { src: "inside_the_bottom_hub.jpg", alt: "Inni í neðri Hub" },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Slakaðu á í hjónarúmi",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Farðu í sturtu í kímónóunum okkar",
            },
            { src: "hallway.jpg", alt: "Gangur" },
            { src: "men_s_bathroom.jpg", alt: "Snyrting karla" },
            { src: "women_s_bathroom.jpg", alt: "Snyrting kvenna" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Ókeypis Rituals baðvörur",
            },
            {
              src: "sweat_it_out_in_our_sauna.jpg",
              alt: "Slakaðu á í gufubaðinu",
            },
          ],
        },
        twinHub: {
          title: "Twin Hub",
          excerpt:
            "Sama stærð og Hub, en skipt í 2 einbreiðar dýnur með aðskildum sængum og skilrúmi. Tilvalið fyrir 2 einstaklinga sem vilja sitt eigið rými. Frábært fyrir vini eða systkini.",
          description:
            "Sama stærð og Hub, en skipt í 2 einbreiðar dýnur með aðskildum sængum og skilrúmi. Tilvalið fyrir 2 einstaklinga sem vilja sitt eigið rými. Frábært fyrir vini eða systkini.",
          imagePath: "/assets/images/accomodation/twinHub_CPH/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Hub-inn er lagaður eins og L",
            },
            { src: "inside_the_top_twin_hub.jpg", alt: "Inni í efri Twin Hub" },
            {
              src: "inside_the_bottom_twin_hub.jpg",
              alt: "Inni í neðri Twin Hub",
            },
            {
              src: "two_separate_beds_with_a_divider.jpg",
              alt: "2 einbreiðar dýnur með skilrúmi",
            },
            { src: "men_s_bathroom.jpg", alt: "Snyrting karla" },
            { src: "women_s_bathroom.jpg", alt: "Snyrting kvenna" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Ókeypis Rituals baðvörur",
            },
            {
              src: "sweat_it_out_in_our_sauna.jpg",
              alt: "Slakaðu á í gufubaðinu",
            },
          ],
        },
        room: {
          title: "Quad Room",
          excerpt:
            "Vantar þig meira pláss? Quad Room rúmar allt að 4 ferðalanga. Tilvalið fyrir vini eða fjölskyldur. Kemur með sérbaðherbergi. Hentar einnig hreyfihömluðum.",
          description:
            "Vantar þig meira pláss? Quad Room rúmar allt að 4 ferðalanga. Tilvalið fyrir vini eða fjölskyldur. Kemur með sérbaðherbergi. Hentar einnig hreyfihömluðum.",
          imagePath: "/assets/images/accomodation/quadRoom_CPH/",
          images: [
            {
              src: "quad_room_with_4_bunk_beds.jpg",
              alt: "Quad Room með 4 kojum",
            },
            {
              src: "quad_room_with_a_double_bed_and_2_bunks.jpg",
              alt: "Quad Room með hjónarúmi og 2 kojum",
            },
            { src: "private_bathroom.jpg", alt: "Sérbaðherbergi" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Hressaðu þig við undir regnsturtunni",
            },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Ókeypis Rituals baðvörur",
            },
            {
              src: "sweat_it_out_in_our_sauna.jpg",
              alt: "Slakaðu á í gufubaðinu",
            },
          ],
        },
        howManyTravellers: {
          title: "Hversu margir ferðalangar?",
          content:
            'Öll rýmin okkar bjóða upp á þægileg rúm, stemningslýsingu og nýjustu tækni. Eina spurningin er: hvernig vilt þú dvelja? <ul className="list-disc p-4"><li>Ferðast einn eða sem par og vilt næði og notalega stemningu? → Veldu Hub.</li><li>Eruð þið tvö en viljið frekar aðskilin rúm (vinir eða samstarfsfólk)? → Twin Hub er fullkominn.</li><li>Ertu að leita að rúmbetra herbergi með sérbaðherbergi? → Veldu Quad Room.</li></ul>Hvað sem þú velur þá muntu sofa vel.<br />Veldu 1 eða 2 gesti til að sjá verðbreytingar.',
        },
        addAnotherAccomodation: {
          title: "Bæta við annarri gistingu",
          hub: {
            title: "Hub",
            description:
              "Einka Hub með hjónarúmi – fullkomið fyrir einn eða tvo ferðalanga.",
          },
          twinHub: {
            title: "Twin Hub",
            description:
              "Einka Hub með tveimur einbreiðum rúmum og skilrúmi – tilvalið fyrir vini eða systkini.",
          },
          room: {
            title: "Quad Room",
            description:
              "Einkaherbergi með kojum og sérbaðherbergi – fullkomið fyrir allt að fjóra ferðalanga.",
          },
        },
      },
      RKV: {
        tags: ["Heitur pottur á þakinu"],
        hub: {
          title: "Hub",
          excerpt:
            "Þinn eigin einka Hub fyrir allt að 2 ferðalanga með king-size rúmi. Fullkomið fyrir ferðalanga á eigin vegum, vini eða pör sem elska þægindi.",
          description:
            "Þinn eigin einka Hub fyrir allt að 2 ferðalanga með king-size rúmi. Fullkomið fyrir ferðalanga á eigin vegum, vini eða pör sem elska þægindi.",
          imagePath: "/assets/images/accomodation/hub_RKV/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Hub-inn er lagaður eins og L",
            },
            { src: "see_the_top_hub.jpg", alt: "Sjá efri Hub" },
            { src: "inside_the_top_hub.jpg", alt: "Inni í efri Hub" },
            { src: "see_the_bottom_hub.jpg", alt: "Sjá neðri Hub" },
            { src: "inside_the_bottom_hub.jpg", alt: "Inni í neðri Hub" },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Slakaðu á í hjónarúmi",
            },
            {
              src: "yes_you_can_sit_up_in_bed.jpg",
              alt: "Já, þú getur setið uppréttur í rúminu",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Farðu í sturtu í kímónóunum okkar",
            },
            { src: "women_s_bathroom.jpg", alt: "Snyrting kvenna" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Ókeypis Rituals baðvörur",
            },
            { src: "men_s_bathroom.jpg", alt: "Snyrting karla" },
            {
              src: "relax_in_our_rooftop_hot_tub.jpg",
              alt: "Slakaðu á í heita pottinum á þakinu",
            },
          ],
        },
        twinHub: {
          title: "Twin Hub",
          excerpt:
            "Sama stærð og Hub, en skipt í 2 einbreiðar dýnur með aðskildum sængum og skilrúmi. Tilvalið fyrir 2 einstaklinga sem vilja sitt eigið rými. Frábært fyrir vini eða systkini.",
          description:
            "Sama stærð og Hub, en skipt í 2 einbreiðar dýnur með aðskildum sængum og skilrúmi. Tilvalið fyrir 2 einstaklinga sem vilja sitt eigið rými. Frábært fyrir vini eða systkini.",
          imagePath: "/assets/images/accomodation/twinHub_RKV/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Hub-inn er lagaður eins og L",
            },
            { src: "inside_the_top_twin_hub.jpg", alt: "Inni í efri Twin Hub" },
            {
              src: "inside_the_bottom_twin_hub.jpg",
              alt: "Inni í neðri Twin Hub",
            },
            {
              src: "two_separate_beds_with_a_divider.jpg",
              alt: "2 einbreiðar dýnur með skilrúmi",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Farðu í sturtu í kímónóunum okkar",
            },
            { src: "women_s_bathroom.jpg", alt: "Snyrting kvenna" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Ókeypis Rituals baðvörur",
            },
            { src: "men_s_bathroom.jpg", alt: "Snyrting karla" },
            {
              src: "relax_in_our_rooftop_hot_tub.jpg",
              alt: "Slakaðu á í heita pottinum á þakinu",
            },
          ],
        },
        movieHub: {
          title: "Movie Hub",
          excerpt: "Einka Hub með hjónarúmi og stórum sjónvarpsskjá.",
          description:
            "Þetta litla herbergi fyrir allt að 2 ferðalanga er með hjónarúmi og stórum sjónvarpsskjá. Frábært til að horfa á kvikmyndir uppi í rúmi.",
          imagePath: "/assets/images/accomodation/movieHub_RKV/",
          images: [
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Slakaðu á í hjónarúmi",
            },
            {
              src: "large_tv_for_your_favourite_shows.jpg",
              alt: "Stórt sjónvarp fyrir uppáhaldsþættina þína",
            },
            { src: "women_s_bathroom.jpg", alt: "Snyrting kvenna" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Ókeypis Rituals baðvörur",
            },
            { src: "men_s_bathroom.jpg", alt: "Snyrting karla" },
            {
              src: "relax_in_our_rooftop_hot_tub.jpg",
              alt: "Slakaðu á í heita pottinum á þakinu",
            },
          ],
        },
        howManyTravellers: {
          title: "Hversu margir ferðalangar?",
          content:
            'Öll rýmin okkar bjóða upp á þægileg rúm, stemningslýsingu og nýjustu tækni. Eina spurningin er: hvernig vilt þú dvelja? <ul className="list-disc p-4"><li>Ferðast einn eða sem par og vilt næði og notalega stemningu? → Veldu Hub.</li><li>Eruð þið tvö en viljið frekar aðskilin rúm (vinir eða samstarfsfólk)? → Twin Hub er fullkominn.</li><li>Ertu að leita að hefðbundnara herbergi með stóru sjónvarpi (Sameiginlegt baðherbergi)? → Veldu Movie Hub.</li></ul>Hvað sem þú velur þá muntu sofa vel.<br />Veldu 1 eða 2 gesti til að sjá verðbreytingar.',
        },
        addAnotherAccomodation: {
          title: "Bæta við annarri gistingu",
          hub: {
            title: "Hub",
            description:
              "Einka Hub með hjónarúmi – fullkomið fyrir einn eða tvo ferðalanga.",
          },
          twinHub: {
            title: "Twin Hub",
            description:
              "Einka Hub með 2 einbreiðum rúmum og skilrúmi – tilvalið fyrir vini eða systkini.",
          },
          movieHub: {
            title: "Movie Hub",
            description:
              "Lítið einkaherbergi með hjónarúmi og sjónvarpi – fullkomið fyrir allt að tvo ferðalanga.",
          },
        },
      },
      RTM: {
        tags: [],
        hub: {
          title: "Hub",
          excerpt:
            "Þinn eigin einka Hub fyrir allt að 2 ferðalanga með king-size rúmi. Fullkomið fyrir ferðalanga á eigin vegum, vini eða pör sem elska þægindi.",
          description:
            "Þinn eigin einka Hub fyrir allt að 2 ferðalanga með king-size rúmi. Fullkomið fyrir ferðalanga á eigin vegum, vini eða pör sem elska þægindi.",
          imagePath: "/assets/images/accomodation/hub_RTM/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Hub-inn er lagaður eins og L",
            },
            { src: "see_the_top_hub.jpg", alt: "Sjá efri Hub" },
            { src: "inside_the_top_hub.jpg", alt: "Inni í efri Hub" },
            { src: "see_the_bottom_hub.jpg", alt: "Sjá neðri Hub" },
            { src: "inside_the_bottom_hub.jpg", alt: "Inni í neðri Hub" },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Slakaðu á í hjónarúmi",
            },
            {
              src: "yes_you_can_sit_up_in_bed.jpg",
              alt: "Já, þú getur setið uppréttur í rúminu",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Farðu í sturtu í kímónóunum okkar",
            },
            { src: "women_s_bathroom.jpg", alt: "Snyrting kvenna" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Hressaðu þig við undir regnsturtunni",
            },
            { src: "men_s_bathroom.jpg", alt: "Snyrting karla" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Ókeypis Rituals baðvörur",
            },
          ],
        },
        twinHub: {
          title: "Twin Hub",
          excerpt:
            "Sama stærð og Hub, en skipt í 2 einbreiðar dýnur með aðskildum sængum og skilrúmi. Tilvalið fyrir 2 einstaklinga sem vilja sitt eigið rými. Frábært fyrir vini eða systkini.",
          description:
            "Sama stærð og Hub, en skipt í 2 einbreiðar dýnur með aðskildum sængum og skilrúmi. Tilvalið fyrir 2 einstaklinga sem vilja sitt eigið rými. Frábært fyrir vini eða systkini.",
          imagePath: "/assets/images/accomodation/twinHub_RTM/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Hub-inn er lagaður eins og L",
            },
            {
              src: "inside_the_bottom_twin_hub.png",
              alt: "Inni í neðri Twin Hub",
            },
            {
              src: "relax_in_your_king_size_bed.png",
              alt: "Slakaðu á í hjónarúmi",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Farðu í sturtu í kímónóunum okkar",
            },
            { src: "women_s_bathroom.jpg", alt: "Snyrting kvenna" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Hressaðu þig við undir regnsturtunni",
            },
            { src: "men_s_bathroom.jpg", alt: "Snyrting karla" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Ókeypis Rituals baðvörur",
            },
          ],
        },
        howManyTravellers: {
          title: "Hversu margir ferðalangar?",
          content:
            'Öll rýmin okkar bjóða upp á þægileg rúm, stemningslýsingu og nýjustu tækni. Eina spurningin er: hvernig vilt þú dvelja? <ul className="list-disc p-4"><li>Ferðast einn eða sem par og vilt næði og notalega stemningu? → Veldu Hub.</li><li>Eruð þið tvö en viljið frekar aðskilin rúm (vinir eða samstarfsfólk)? → Twin Hub er fullkominn.</li></ul>Hvað sem þú velur þá muntu sofa vel.<br />Veldu 1 eða 2 gesti til að sjá verðbreytingar.',
        },
        addAnotherAccomodation: {
          title: "Bæta við annarri gistingu",
          hub: {
            title: "Hub",
            description:
              "Einka Hub með hjónarúmi – fullkomið fyrir einn eða tvo ferðalanga.",
          },
          twinHub: {
            title: "Twin Hub",
            description:
              "Einka Hub með tveimur einbreiðum rúmum og skilrúmi – tilvalið fyrir vini eða systkini.",
          },
        },
      },
      tags: {
        hub: [
          "Einka Hub fyrir 1-2 einstaklinga",
          "1 hjónarúm",
          "Sameiginleg baðherbergi",
          "Rituals baðvörur",
          "Handklæði",
          "Kímónó",
        ],
        twinHub: [
          "Einka Hub fyrir 2 einstaklinga",
          "2 einbreiðar dýnur með skilrúmi",
          "Sameiginleg baðherbergi",
          "Rituals baðvörur",
          "Handklæði",
          "Kímónó",
        ],
        room: [
          "20m² herbergi fyrir 1-4 einstaklinga",
          "4 kojur eða 2 kojur og hjónarúm",
          "Sérbaðherbergi",
          "Rituals baðvörur",
          "Handklæði",
          "Kímónó",
          "Aðgengi fyrir hjólastóla",
        ],
        movieHub: [
          "Einka Hub fyrir 1-2 einstaklinga",
          "1 hjónarúm",
          "Sameiginleg baðherbergi",
          "Rituals baðvörur",
          "Handklæði",
          "Kímónó",
          "Sjónvarp",
        ],
      },
      faq: {
        hub: [
          {
            q: "Efri eða neðri Hub? Má ég velja?",
            a: "Já. Hub er þín eigin „svefnaðstaða“ / „hvíldarhylki“, lagaður eins og L og gerður fyrir 2 einstaklinga. Hub-unum er staflað í pörum, einn efri og einn neðri. Við innritun færðu að velja hvort þú vilt klifra upp eða dýfa þér í rúmið.",
          },
          {
            q: "Segðu mér meira um þessa Hub-a.",
            a: "6m² Hub-inn þinn er búinn snjöllu geymsluplássi, rafmagnsinnstungum og WiFi. Rúmin eru uppábúin. Þú getur stillt ljós Hub-sins eftir skapi þínu með CityHub appinu. Hub-inn býður upp á Bluetooth tónlistarstreymi.",
          },
          {
            q: "Er loftkæling í Hub-num?",
            a: "Já, Hub-inn er tengdur miðlægu loftslagskerfi sem er stillt á þægilegt hitastig fyrir flesta gesti.",
          },
          {
            q: "Hvernig eru baðherbergin?",
            a: "Frekar glæsileg. Þau eru sameiginleg en aðskilin fyrir konur og karla, með regnsturtum og ókeypis baðvörum frá Rituals. Við höldum þeim hreinum allan daginn, alla daga.",
          },
          {
            q: "Eru handklæði í boði? Hvað annað þarf ég ekki að taka með?",
            a: "Við erum með allt fyrir þig. Handklæði, Rituals-sápu, sjampó, hárblásara og já, straujárn. Vissirðu að við bjóðum einnig upp á sérstakar CityHub-kímóna? Mjög þægilegt þegar farið er í sturtu. Mundu þó að koma með þínar eigin inniskó.",
          },
          {
            q: "Má ég koma með börn?",
            a: "Við elskum börn, svo sannarlega! Því miður er sameiginleg aðstaða okkar ekki hentug fyrir ungabörn og börn yngri en 6 ára. Athugið að Hub rúmar að hámarki 2 manns, börn eru þar meðtalin.",
          },
        ],
        twinHub: [
          {
            q: "Efri eða neðri Hub? Má ég velja?",
            a: "Já. Hub er þín eigin „svefnaðstaða“ / „hvíldarhylki“, lagaður eins og L og gerður fyrir 2 einstaklinga. Hub-unum er staflað í pörum, einn efri og einn neðri. Við innritun færðu að velja hvort þú vilt klifra upp eða dýfa þér í rúmið.",
          },
          {
            q: "Segðu mér meira um þessa Hub-a.",
            a: "6m² Hub-inn þinn er búinn snjöllu geymsluplássi, rafmagnsinnstungum og WiFi. Rúmin eru uppábúin. Þú getur stillt ljós Hub-sins eftir skapi þínu með CityHub appinu. Hub-inn býður upp á Bluetooth tónlistarstreymi.",
          },
          {
            q: "Er loftkæling í Hub-num?",
            a: "Já, Hub-inn er tengdur miðlægu loftslagskerfi sem er stillt á þægilegt hitastig fyrir flesta gesti.",
          },
          {
            q: "Hvernig eru baðherbergin?",
            a: "Frekar glæsileg. Þau eru sameiginleg en aðskilin fyrir konur og karla, með regnsturtum og ókeypis baðvörum frá Rituals. Við höldum þeim hreinum allan daginn, alla daga.",
          },
          {
            q: "Eru handklæði í boði? Hvað annað þarf ég ekki að taka með?",
            a: "Við erum með allt fyrir þig. Handklæði, Rituals-sápu, sjampó, hárblásara og já, straujárn. Vissirðu að við bjóðum einnig upp á sérstakar CityHub-kímóna? Mjög þægilegt þegar farið er í sturtu. Mundu þó að koma með þínar eigin inniskó.",
          },
          {
            q: "Má ég koma með börn?",
            a: "Við elskum börn, svo sannarlega! Því miður er sameiginleg aðstaða okkar ekki hentug fyrir ungabörn og börn yngri en 6 ára. Athugið að Hub rúmar að hámarki 2 manns, börn eru þar meðtalin.",
          },
        ],
        room: [
          {
            q: "Segðu mér meira um þetta Quad room.",
            a: "Quad Room herbergið þitt er með sérbaðherbergi og er búið innstungum og WiFi. Rúmin eru uppábúin. Þú getur stillt ljósin í herberginu eftir skapi þínu með CityHub appinu. Bluetooth tónlistarstreymi er innifalið.",
          },
          {
            q: "Er loftkæling í Quad room?",
            a: "Já, Quad room herbergið þitt er tengt miðlægu loftslagskerfi sem er stillt á þægilegt hitastig fyrir flesta ferðalanga.",
          },
          {
            q: "Eru handklæði í boði? Hvað annað þarf ég ekki að taka með?",
            a: "Við erum með allt fyrir þig. Handklæði, Rituals-sápu, sjampó, hárblásara og já, straujárn. Vissirðu að við bjóðum einnig upp á sérstakar CityHub-kímóna? Mjög þægilegt þegar farið er í sturtu. Mundu þó að koma með þínar eigin inniskó.",
          },
          {
            q: "Má ég koma með börn?",
            a: "Við elskum börn, svo sannarlega! Því miður er sameiginleg aðstaða okkar ekki hentug fyrir ungabörn og börn yngri en 6 ára. Athugið að Quad Room rúmar að hámarki 4 manns, börn eru þar meðtalin.",
          },
        ],
        movieHub: [
          {
            q: "Segðu mér meira um þennan Movie Hub.",
            a: "Movie Hub-inn þinn er búinn snjöllu geymsluplássi, rafmagnsinnstungum, WiFi og stórum sjónvarpsskjá. Rúmin eru uppábúin. Þú getur stillt ljósin eftir skapi þínu með CityHub appinu. Inniheldur einnig Bluetooth tónlistarstreymi.",
          },
          {
            q: "Er loftkæling í Movie Hub-num?",
            a: "Já, Movie Hub-inn þinn er tengdur miðlægu loftslagskerfi sem er stillt á þægilegt hitastig fyrir flesta ferðalanga.",
          },
          {
            q: "Hvernig eru baðherbergin?",
            a: "Frekar glæsileg. Þau eru sameiginleg en aðskilin fyrir konur og karla, með regnsturtum og ókeypis baðvörum. Við höldum þeim hreinum allan daginn, alla daga.",
          },
          {
            q: "Eru handklæði í boði? Hvað annað þarf ég ekki að taka með?",
            a: "Við erum með allt fyrir þig. Handklæði, Rituals-sápu, sjampó, hárblásara og já, straujárn. Vissirðu að við bjóðum einnig upp á sérstakar CityHub-kímóna? Mjög þægilegt þegar farið er í sturtu. Mundu þó að koma með þínar eigin inniskó.",
          },
          {
            q: "Má ég koma með börn?",
            a: "Við elskum börn, svo sannarlega! Því miður er sameiginleg aðstaða okkar ekki hentug fyrir ungabörn og börn yngri en 6 ára. Athugið að Hub rúmar að hámarki 2 manns, börn eru þar meðtalin.",
          },
        ],
      },
    },
    modal: {
      selectHotel: {
        title: "Veldu borg",
        button: { label: "Veldu borg" },
      },
      selectCulture: {
        title: "Tungumál og gjaldmiðill",
        button: { label: "Vista breytingar" },
      },
      uspBar: {
        title: "Lægsta verð tryggt",
        content:
          "Við ábyrgjumst að ef þú bókar í gegnum þessa vefsíðu færðu alltaf besta mögulega verðið.",
      },
    },
    component: {
      uspBar: {
        title: "Lægsta verð tryggt",
      },
    },
    scenes: {
      traveller_one: "ferðalangur",
      traveller_other: "ferðalangar",
      night_one: "nótt",
      night_other: "nætur",
      selectHotel: {
        chooseCity: "Bókaðu núna, veldu þína borg",
      },
      accommodation: {
        pricePerNight: "Verð á nótt",
        pricePerNightInclVat: "Verð á nótt (m. VSK)",
        remove: "Fjarlægja",
        directBookingDiscount: "Afsláttur fyrir beina bókun",
        notAvailable: "ekki laust",
        unavailable: "Ekki laust",
        noMoreRoomsAvailable: "Bóka núna · síðasta Hub",
        addAnotherRoom: "Bæta við herbergi",
        addAnotherHub: "Bæta við Hub",
        howManyTravellers: "Hversu margir ferðalangar?",
        questions: "Algengar spurningar",
        moreTags_one: "fleiri eiginleikar",
        moreTags_other: "fleiri eiginleikar",
        more_info: "Fleiri upplýsingar",
        not_available: "Ekki í boði á þessari dagsetningu",
        show_more: "Fleiri upplýsingar",
        show_less: "Minni upplýsingar",
        selected: "valið",
      },
      calendar: {
        startNotice: "{{hotelName}} opnar dyr sínar {{startDate}}",
      },
      extras: {
        perPersonPerNight: "á mann, á nótt",
        add: "Bæta við",
        remove: "Fjarlægja",
        moreInfo: "Fleiri upplýsingar",
      },
      summary: {
        perNight: "/ nótt",
        checkIn: "INNRITUN",
        checkOut: "ÚTRITUN",
        rate: "Verð:",
        discount: "Afsláttur:",
        from: "Frá",
        before: "Fyrir",
        total: "Samtals",
        incCityTax: "Gistináttaskattur",
        incVat: "Innifalið VSK",
        incVatRooms: "Innifalið VSK herbergja",
        incVatProducts: "Innifalið VSK vöru",
        directBookingDiscount: "Afsláttur fyrir beina bókun",
        voucher: "Gjafakóði",
        addVoucher: "Bæta við gjafakóða",
        voucherInvalid: "Þessi kóði er ógildur",
        voucherNotApplicable: "Þessi kóði gildir ekki fyrir valið verð",
      },
      details: {
        firstName: "Fornafn",
        firstNameRequired: "Fornafn vantar",
        lastName: "Eftirnafn",
        lastNameRequired: "Eftirnafn vantar",
        email: "Netfang",
        emailRequired: "Netfang vantar",
        emailInvalid:
          "Netfang verður að innihalda @ og að minnsta kosti einn punkt",
        phoneMin: "Símanúmer þarf að vera að minnsta kosti 9 tölustafir",
        phoneInvalid: "Símanúmer verður að vera tölustafir",
        countryRequired: "Land er nauðsynlegur reitur",
        phone: "Símanúmer",
        country: "Land",
        selectCountry: "Veldu þitt land",
        specialRequests: "Sérstakar óskir",
        terms:
          "Ég samþykki <firstLink>skilmála gististaðarins</firstLink> og <secondLink>persónuverndarstefnu.</secondLink>",
        marketingEmails: "Ég vil fá tilkynningar um kynningar af og til.",
        createReservation: "Stofna bókun",
        finishPaymentAtKiosk:
          "Ljúktu greiðslu í sjálfsafgreiðsluvélinni okkar.",
        creatingReservation: "Bý til bókun þína...",
        reservationCreated: "Bókun stofnuð!",
        somethingWentWrong:
          "Eitthvað fór úrskeiðis, vinsamlegast reyndu aftur.",
      },
      payment: {
        paymentMethods: "Greiðslumátar",
        paymentMethodsDescription:
          "Aðeins eitt skref eftir. Ljúktu greiðslu þinni á öruggan hátt hér að neðan. Við notum dulkóðaðar greiðsluaðferðir til að vernda upplýsingarnar þínar. Þegar greiðslan er staðfest færðu staðfestingarpóst.",
        authorizeCreditCard: "Staðfesta kreditkort",
        cardChargeInfo:
          "Kortið þitt verður gjaldfært 48 klukkustundum fyrir komu",
        securedWithMews: "Tryggt með Mews Payments í gegnum PCI Proxy",
        payWithCreditCard: "Greiða með kreditkorti",
        payDirectly: "Greiða strax",
        onlyVisaAndMastercardSupported:
          "Aðeins Visa og MasterCard eru samþykkt",
        nameOnCreditCard: "Nafn á korti",
        cardNumber: "Kortanúmer",
        expirationDate: "Gildistími",
        expirationDateRequired: "Gildistíma vantar",
        yearCanNotBeInThePast: "Ár getur ekki verið í fortíðinni",
        "yearCanNotBeMoreThan 5YearsInTheFuture":
          "Ár má ekki vera meira en 5 ár í framtíðinni",
        monthCanNotBeInThePast: "Mánuður getur ekki verið í fortíðinni",
        monthCanNotBeBiggerThan12: "Mánuður getur ekki verið stærri en 12",
        shouldBeAMonthAndAYear: "Ætti að vera mánuður og ár MM/ÁÁÁÁ",
        validateCard: "Staðfesta kort",
        createReservation: "Stofna bókun",
        nameIsRequired: "Nafn vantar",
        cardNumberIsRequired: "Kortanúmer vantar",
        invalidCardNumber: "Ógilt kortanúmer",
        cvcIsRequired: "CVC vantar",
        invalidCvc: "Ógilt CVC",
        somethingWentWrong:
          "Eitthvað fór úrskeiðis. Vinsamlegast reyndu aftur síðar.",
        somethingWentWrong4501:
          "Eitthvað fór úrskeiðis (4501). Vinsamlegast reyndu aftur síðar.",
        creatingReservation: "Bý til bókun þína...",
        reservationCreated: "Bókun stofnuð!",
        finishPayment: "Gengið frá greiðslu þinni...",
        creditcardNotAuthorizable: "Ekki tókst að staðfesta kreditkort",
      },
      success: {
        bookingConfirmed: "Bókun staðfest!",
        bookingConfirmedDescription:
          "Gisting þín hjá {{hotelName}} er klár. <br/>Innritun frá 15:00. Sjáumst fljótlega 👋",
        startChatting: "Byrja að spjalla",
        viewBookingDetails: "Sjá upplýsingar um bókun",
        bookingDetails: "Upplýsingar um bókun",
        whatsNext: "Hvað svo?",
        connectWithHost:
          "Hafðu samband við CityHost-inn þinn, þinn persónulega tengilið allan sólarhringinn fyrir ráðleggingar, leiðbeiningar og staðarleyndarmál.",
        online: "Á NETINU",
      },
      pageNotFound: {
        message: "Úbbs! <br />Við finnum ekki síðuna sem þú ert að leita að.",
        linkText: "Veldu hótel til að byrja",
      },
      redirectHotel: {
        message: "Hleð uppsetningu hótels...",
      },
      redirectPayment: {
        error4602: "[villa" + ":4602] Engin bókun fannst",
        noPaymentsFound: "Engar greiðslur fundust",
        paymentSuccessful: "Greiðsla tókst",
        paymentFailed: "Greiðsla mistókst",
        returningToSite: "Sný aftur á vefsíðuna...",
        authorizationPending: "Heimild í bið",
        authorizationPendingMessage:
          "Bókunin þín hefur verið stofnuð en heimildin er enn í bið.<br /><br />Smelltu hér til að staðfesta kortið þitt.",
      },
    },
    form: {
      language: {
        label: "Tungumál",
        placeholder: "Veldu tungumál",
        options: {
          "en-US": "Enska",
          "nl-NL": "Hollenska",
          "is-IS": "Íslenska",
          "de-DE": "Þýska",
          "fr-FR": "Franska",
          "it-IT": "Ítalska",
        },
        validation: { required: "Vinsamlegast veldu tungumál" },
      },
      currency: {
        label: "Gjaldmiðill",
        placeholder: "Veldu gjaldmiðil",
        options: {
          EUR: "Evra (€)",
          USD: "Bandaríkjadalur ($)",
          GBP: "Breskt pund (£)",
          CAD: "Kanadískur dalur (C$)",
          DKK: "Dönsk króna (DKK)",
          ISK: "Íslensk króna (ISK)",
        },
        validation: { required: "Vinsamlegast veldu gjaldmiðil" },
      },
    },
  },
};
